import { render, staticRenderFns } from "./common.vue?vue&type=template&id=c566cf14&scoped=true"
import script from "./common.vue?vue&type=script&lang=js"
export * from "./common.vue?vue&type=script&lang=js"
import style0 from "./common.vue?vue&type=style&index=0&id=c566cf14&prod&lang=css"
import style1 from "./common.vue?vue&type=style&index=1&id=c566cf14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c566cf14",
  null
  
)

export default component.exports